import { render, staticRenderFns } from "./OrmBatchStatistics2.vue?vue&type=template&id=55997686&scoped=true"
import script from "./OrmBatchStatistics2.vue?vue&type=script&lang=js"
export * from "./OrmBatchStatistics2.vue?vue&type=script&lang=js"
import style0 from "./OrmBatchStatistics2.vue?vue&type=style&index=0&id=55997686&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55997686",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55997686')) {
      api.createRecord('55997686', component.options)
    } else {
      api.reload('55997686', component.options)
    }
    module.hot.accept("./OrmBatchStatistics2.vue?vue&type=template&id=55997686&scoped=true", function () {
      api.rerender('55997686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ormbatching/components/OrmBatchStatistics2.vue"
export default component.exports